import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { HEADER_HEIGHT } from '~/core/utils';

const MODULE_HEADER_HEIGHT = 81;
export const PlayerContainerSmall = styled.div<{ $isFixed: boolean }>`
    ${BaseStyle.Mixins.gaps.small};
    align-items: center;
    background: ${({ theme }) => theme.Surface.primary};
    display: flex;
    padding-bottom: 8px;
    padding-top: 14px;
    position: sticky;
    justify-content: space-between;
    top: ${HEADER_HEIGHT + MODULE_HEADER_HEIGHT}px;
    transition: box-shadow 0.5s;

    ${({ $isFixed }) =>
        $isFixed &&
        css`
            box-shadow:
                0 2px 2px -2px rgba(0, 0, 0, 0.12),
                0 8px 4px -4px rgba(0, 0, 0, 0.08);
        `};
`;

export const PlayerContainerLarge = styled.div`
    ${BaseStyle.Mixins.gaps.small};
    align-items: center;
    display: flex;
    flex-direction: column;
    padding-top: 20px;
`;

export const ImgContainer = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
`;

export const NameContainerSmall = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']};
    padding-left: 4px;
`;

export const NameContainerLarge = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['24b']};
    ${BaseStyle.Mixins.gaps.extraSmall};
    align-items: center;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding-top: 2px;
    padding-bottom: 8px;
`;

export const PlayerNameDetailContainerSmall = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall};
    display: flex;
    flex: 1;
    flex-direction: column;
    padding-top: 8px;
`;

export const PlayerDetailContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    color: ${({ theme }) => theme.Text.secondary};
    display: flex;
    align-items: center;
    margin-right: -2px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['16m']};
        margin-right: 0;
    }

    .team-logo {
        margin-right: 1px;
        height: 20px;
    }
`;

export const TeamIcon = styled(TeamDisplay)`
    && {
        flex: initial;
    }
`;

export const StatDetails = styled.div`
    display: flex;
    flex-direction: column-reverse;
    justify-content: end;
    text-align: center;
    gap: 2px;
    padding-top: 2px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.extraSmall};
        flex: 1;
        flex-direction: column;
        padding-top: 0;
    }
`;

export const StatCategoryName = styled.p`
    ${BaseStyle.Mixins.fontStyles.ui['14m']};
    color: ${({ theme }) => theme.Text.secondary};
    text-transform: uppercase;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['16b']};
    }
`;

export const StatCategoryValue = styled.p`
    ${BaseStyle.Mixins.fontStyles.ui['32b']};

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['80b']};
    }
`;

export const PlayerInfoSmall = styled.a`
    ${BaseStyle.Mixins.gaps.extraSmall};
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const PlayerInfoLarge = styled.a`
    ${BaseStyle.Mixins.gaps.small};
    display: flex;
    flex-direction: column;
`;
